/**
 * @param { string } str String to convert to number.
 * @returns { number } Numbers from string as number, removes all non-numeric characters.
 */
export function convertStringToNumber(str) {
  const onlyNumbers = str.replace(/\D/g, '');
  return Number(onlyNumbers);
}
